window.addEventListener('DOMContentLoaded', (event) => {
  $('.js-checkout-btn').on('click', function(event) {
    if (event.originalEvent) {
      event.preventDefault();
  
      fetch('/cart.js')
        .then(response => response.json())
        .then(response => {
          let onlyFreeSamples = response.items.length > 0 ? true : false;
  
          for (const line_item of response.items) {
            if (line_item.product_type === 'Sample') {
              onlyFreeSamples = true;
            } else {
              onlyFreeSamples = false;
              break;
            }
          }
  
          if (onlyFreeSamples) {
            location.href = location.href;
          } else {
            $(this).trigger('click');
          }
        })
    }
  })
});
